import React from 'react';
import { ParamsCtx } from './paramsCtx';
import Loader from 'components/atoms/loader/Loader';
import { useParamsState } from './useParamsState/useParamsState';

export function withParamsState(Component, options) {
  const WithStateComponent = (props) => {
    const state = useParamsState(options);

    if (state.isLoadingParams && !state.values) {
      return <Loader spinner={true} />;
    }

    return (
      <ParamsCtx.Provider value={state}>
        <Component
          {...props}
          state={state}
        />
      </ParamsCtx.Provider>
    );
  };

  WithStateComponent.displayName = Component.displayName || Component.name;

  return WithStateComponent;
}
